import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';

import Socials from 'components/bolt/socials/socials';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			showHeader: true
		};

		Store.on('TOGGLE_INTERSTITIAL_OPEN', () => {
			this.setState({ showHeader: false });
		});

		Store.on('TOGGLE_INTERSTITIAL_OPEN', (isOpen) => {
			if (!isOpen) {
				this.setState({ showHeader: true });
			}
		});
	}

	renderPersistentButton() {
		const socials = this.props.appData?.header?.powsterHeader?.follow;
		const activePage = Store.get().activePage;
		const pageLowerCase = activePage.toLowerCase();
		const headerOpen = this.props.headerData.open;
		const isShowtimes = pageLowerCase.includes('showtimes');
		const isHomeEnt = pageLowerCase.includes('homeent');
		const isShowtimesOrHomeEnt = isShowtimes || isHomeEnt;
		if (!socials) return;
		const hubHeroScrolledAway = this.props.hubActivePercentage < 0.4;

		return (
			<Socials
				class={joinClasses(
					s.socials,
					headerOpen && s.open,
					(!headerOpen && isShowtimesOrHomeEnt) && s.hideSocials,
					hubHeroScrolledAway && s.hubHeroScrolledAway,
					this.props.isHubTypePage && s.isHubTypePage
				)}
				socials={socials}
				navOpen={this.props.headerData.open}
				key="socials"
			/>
		);
	}

	render(props) {
		if (!this.state.showHeader) {
			return null;
		}
		return super.render(props);
	}
}
